import styled from 'styled-components';
import { GlobalToken } from 'antd';

export const CheckboxRow = styled.div<{ theme: { token: GlobalToken } }>`
  display: flex;
  margin-top: ${({ theme: { token } }) => token.marginSM}px;
  margin-left: ${({ theme: { token } }) => token.marginXXS}px;
  gap: ${({ theme: { token } }) => token.marginXL}px;
`;
